import { Component, inject } from '@angular/core';
import { BoFormsModule } from '@bo/ng-forms';
import { FieldComponent } from '../../../../../shared/components/forms/form-field/form-field.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SubmitComponent } from '../../../../../shared/components/forms/submit/submit.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TransactionsApiService } from '../../../../../_services/transactions-service/transactions-api.service';
import { ToastService } from '../../../../../_services/toast-service/toast.service';
import { Method } from '@bo/ng-api';
import {
  TransactionCategory,
  TransactionCategoryNameRequest,
  TransactionCategoryRequest,
} from '../../../../../_interfaces/transactions.interface';
import { AppFormComponent } from '../../../../../shared/classes/app-form';
import { Observable, of } from 'rxjs';
import { LoaderComponent } from '../../../../../shared/components/loader/loader.component';

@Component({
  selector: 'app-manage-category',
  imports: [BoFormsModule, FieldComponent, ReactiveFormsModule, SubmitComponent, LoaderComponent],
  templateUrl: './manage-category.component.html',
})
export class ManageCategoryComponent extends AppFormComponent<TransactionCategoryRequest> {
  readonly ngbActiveModal = inject(NgbActiveModal);
  readonly transactionsApiService = inject(TransactionsApiService);
  readonly toastService = inject(ToastService);

  protected categoryId: number | undefined;
  protected category?: TransactionCategory;
  protected returnUrl: string = '/accounting/categories';
  protected fields: string[] = ['name'];

  getInitialData(): Observable<TransactionCategory> {
    if (this.categoryId) {
      return this.transactionsApiService.getTransactionCategoryById(this.categoryId);
    } else {
      return of({} as TransactionCategory);
    }
  }

  createForm(): void {
    const options$ = this.transactionsApiService.getOptions(
      this.transactionsApiService.URL_TRANSACTIONS_CATEGORY,
      Method.POST,
      true,
    );
    if (this.categoryId) {
      const data$ = this.getInitialData();
      this.subscriptions.add(this.buildFromOptions(options$, data$).subscribe());
    } else {
      this.subscriptions.add(this.buildFromOptions(options$).subscribe());
    }
  }

  handleSubmitSuccess(): void {
    this.ngbActiveModal.close();
    if (this.categoryId) {
      this.toastService.show('You have successfully updated the category name.', 'iconoir-check-circle');
    } else {
      this.toastService.show('You have successfully added a new category.', 'iconoir-check-circle');
    }
  }

  onCancel(): void {
    this.ngbActiveModal.dismiss();
  }

  submitData(formData: TransactionCategory): Observable<TransactionCategory> {
    if (this.categoryId) {
      const data: TransactionCategoryNameRequest = {
        id: this.categoryId,
        name: formData.name,
      };
      return this.transactionsApiService.editTransactionCategoryName(data);
    } else {
      return this.transactionsApiService.createTransactionCategory(formData);
    }
  }
}
